import React from "react";
import { CurrencyFormat } from "views/helpers/CurrencyFormat";

export const bukuBesarTable = (handleCheckDetailAkun) => {
  return [
    {
      title: "Kode Akun",
      render: (rowData) => {
        return (
          <span
            onClick={(e) => {
              handleCheckDetailAkun(rowData.kode_akun);
            }}
            className="text-lightBlue-500 cursor-pointer"
          >
            {rowData.kode_akun}
          </span>
        );
      },
    },
    {
      title: "Nama Akun",
      render: (rowData) => {
        return <span>{rowData.nama_akun}</span>;
      },
    },
    {
      title: "Saldo Awal",
      render: (rowData) => {
        return <span>{CurrencyFormat(rowData.saldo_awal)}</span>;
      },
    },
    {
      title: "Debet",
      render: (rowData) => {
        return <span>{CurrencyFormat(rowData.debet)}</span>;
      },
    },
    {
      title: "Kredit",
      render: (rowData) => {
        return <span>{CurrencyFormat(rowData.kredit)}</span>;
      },
    },
    {
      title: "Saldo Akhir",
      render: (rowData) => {
        return <span>{CurrencyFormat(rowData.saldo_akhir)}</span>;
      },
    },
  ];
};

export const laporanDetailJurnalBukuBesarTable = () => {
  return [
    {
      title: "Nomor Transaksi",
      render: (rowData) => {
        return <span>{rowData.nomor_transaksi}</span>;
      },
    },
    {
      title: "Tanggal Transaksi",
      render: (rowData) => {
        return <span>{rowData.tanggal_transaksi}</span>;
      },
    },
    {
      title: "Nama Anggaran",
      render: (rowData) => {
        return <span>{rowData.nama_anggaran}</span>;
      },
    },
    {
      title: "Keterangan Anggaran",
      render: (rowData) => {
        return <span>{rowData.keterangan_anggaran}</span>;
      },
    },
    {
      title: "Akun",
      render: (rowData) => {
        return <span>{rowData.kode_akun + " - " + rowData.nama_akun}</span>;
      },
    },
    {
      title: "Debet",
      render: (rowData) => {
        return <span>{CurrencyFormat(rowData.debet)}</span>;
      },
    },
    {
      title: "Kredit",
      render: (rowData) => {
        return <span>{CurrencyFormat(rowData.kredit)}</span>;
      },
    },
  ];
};
